// Dummy data for the submissions dashboard prototype
export const DUMMY_EMPLOYEES = [
  {
    id: '1',
    empId: '12',
    name: 'Richard Johnson',
    email: 'richardjohnson@zylker.com',
    department: 'Engineering',
    company: 'Zylker Corp',
    jobTitle: 'Senior Developer',
    dateOfJoining: '01-Jan-2019',
    overallRating: '5',
    currentSalary: '85000',
    suggestedIncrement: '12',
    incrementStartDate: '01-Jan-2025',
    managementApproval: 'Approved',
    incrementLetter: 'Yes',
    reviewPeriodStart: 'Jan-2024',
    reviewPeriodEnd: 'Dec-2024',
    periods: ['Jan-2024 to Dec-2024', 'Jan-2023 to Dec-2023'],
    submissionCount: 2,
    lastSubmission: '2026-03-24T10:30:00',
    ratings: {
      'Did the employee meet their set objectives?': 'Exceeds Expectations',
      'How would you rate their performance on core responsibilities?': 'Exceeds Expectations',
      'Technical Skills (Relevant to the job)': 'Expert',
      'Problem-Solving Abilities': 'Strong',
      'Adaptability and Flexibility': 'Excellent',
      'Professionalism and Work Ethic': 'Exemplary',
      'Accountability and Reliability': 'Outstanding',
      'Punctuality and Attendance': 'Excellent',
      'Achievements Beyond Expectations': 'Yes - Led migration project',
      'Eagerness to learn and adapt to new skill': 'Very High',
    },
    remarks: {
      'Any Complaints or Issues Reported': 'None',
      'Recognition received internally?': 'Yes - Employee of Q3',
      'Any special projects completed?': 'Cloud Migration, CI/CD Pipeline',
      'Recommend increment based on potential?': 'Strongly Recommend',
      'Comfortable with given increment?': 'Yes',
      'Any Other Remarks': 'Exceptional contributor. Ready for tech lead role.',
    },
    filledBy: 'sarah.manager@zylker.com',
    addedTime: '10:00 AM',
  },
  {
    id: '2',
    empId: '15',
    name: 'Priya Sharma',
    email: 'priya.sharma@zylker.com',
    department: 'Marketing',
    company: 'Zylker Corp',
    jobTitle: 'Marketing Manager',
    dateOfJoining: '15-Mar-2020',
    overallRating: '4',
    currentSalary: '72000',
    suggestedIncrement: '10',
    incrementStartDate: '01-Jan-2025',
    managementApproval: 'Approved',
    incrementLetter: 'Yes',
    reviewPeriodStart: 'Jan-2024',
    reviewPeriodEnd: 'Dec-2024',
    periods: ['Jan-2024 to Dec-2024'],
    submissionCount: 1,
    lastSubmission: '2026-03-23T14:20:00',
    ratings: {
      'Did the employee meet their set objectives?': 'Meets Expectations',
      'How would you rate their performance on core responsibilities?': 'Above Average',
      'Technical Skills (Relevant to the job)': 'Proficient',
      'Problem-Solving Abilities': 'Good',
      'Adaptability and Flexibility': 'Good',
      'Professionalism and Work Ethic': 'Excellent',
      'Accountability and Reliability': 'Good',
      'Punctuality and Attendance': 'Good',
      'Achievements Beyond Expectations': 'Brand Campaign +40% engagement',
      'Eagerness to learn and adapt to new skill': 'High',
    },
    remarks: {
      'Any Complaints or Issues Reported': 'None',
      'Recognition received internally?': 'Yes - Best Campaign Award',
      'Any special projects completed?': 'Rebrand Initiative',
      'Recommend increment based on potential?': 'Recommend',
      'Comfortable with given increment?': 'Yes',
      'Any Other Remarks': 'Strong team leader. Consider for VP Marketing.',
    },
    filledBy: 'amit.director@zylker.com',
    addedTime: '2:20 PM',
  },
  {
    id: '3',
    empId: '22',
    name: 'Arjun Patel',
    email: 'arjun.patel@zylker.com',
    department: 'Engineering',
    company: 'Zylker Corp',
    jobTitle: 'Junior Developer',
    dateOfJoining: '01-Aug-2022',
    overallRating: '3',
    currentSalary: '45000',
    suggestedIncrement: '8',
    incrementStartDate: '01-Jan-2025',
    managementApproval: 'Pending',
    incrementLetter: 'No',
    reviewPeriodStart: 'Jan-2024',
    reviewPeriodEnd: 'Dec-2024',
    periods: ['Jan-2024 to Dec-2024'],
    submissionCount: 1,
    lastSubmission: '2026-03-22T09:15:00',
    ratings: {
      'Did the employee meet their set objectives?': 'Partially Met',
      'How would you rate their performance on core responsibilities?': 'Average',
      'Technical Skills (Relevant to the job)': 'Developing',
      'Problem-Solving Abilities': 'Average',
      'Adaptability and Flexibility': 'Good',
      'Professionalism and Work Ethic': 'Good',
      'Accountability and Reliability': 'Average',
      'Punctuality and Attendance': 'Needs Improvement',
      'Achievements Beyond Expectations': 'None notable',
      'Eagerness to learn and adapt to new skill': 'Moderate',
    },
    remarks: {
      'Any Complaints or Issues Reported': 'Late attendance 3 times in Q4',
      'Recognition received internally?': 'No',
      'Any special projects completed?': 'None',
      'Recommend increment based on potential?': 'Recommend with conditions',
      'Comfortable with given increment?': 'Yes',
      'Any Other Remarks': 'Needs mentoring. Potential is there but requires guidance.',
    },
    filledBy: 'sarah.manager@zylker.com',
    addedTime: '9:15 AM',
  },
  {
    id: '4',
    empId: '08',
    name: 'Meera Nair',
    email: 'meera.nair@zylker.com',
    department: 'Finance',
    company: 'Zylker Corp',
    jobTitle: 'Finance Lead',
    dateOfJoining: '10-Jun-2018',
    overallRating: '5',
    currentSalary: '95000',
    suggestedIncrement: '15',
    incrementStartDate: '01-Jan-2025',
    managementApproval: 'Approved',
    incrementLetter: 'Yes',
    reviewPeriodStart: 'Jan-2024',
    reviewPeriodEnd: 'Dec-2024',
    periods: ['Jan-2024 to Dec-2024', 'Jan-2023 to Dec-2023', 'Jan-2022 to Dec-2022'],
    submissionCount: 3,
    lastSubmission: '2026-03-24T08:00:00',
    ratings: {
      'Did the employee meet their set objectives?': 'Exceeds Expectations',
      'How would you rate their performance on core responsibilities?': 'Exceeds Expectations',
      'Technical Skills (Relevant to the job)': 'Expert',
      'Problem-Solving Abilities': 'Exceptional',
      'Adaptability and Flexibility': 'Excellent',
      'Professionalism and Work Ethic': 'Exemplary',
      'Accountability and Reliability': 'Outstanding',
      'Punctuality and Attendance': 'Excellent',
      'Achievements Beyond Expectations': 'Saved 20% on operational costs',
      'Eagerness to learn and adapt to new skill': 'Very High',
    },
    remarks: {
      'Any Complaints or Issues Reported': 'None',
      'Recognition received internally?': 'Yes - CFO Recognition',
      'Any special projects completed?': 'ERP Migration, Audit Automation',
      'Recommend increment based on potential?': 'Strongly Recommend',
      'Comfortable with given increment?': 'Yes',
      'Any Other Remarks': 'Top performer. Ready for Director-level responsibility.',
    },
    filledBy: 'cfo@zylker.com',
    addedTime: '8:00 AM',
  },
  {
    id: '5',
    empId: '31',
    name: 'Karan Mehta',
    email: 'karan.mehta@zylker.com',
    department: 'Sales',
    company: 'Zylker Corp',
    jobTitle: 'Sales Executive',
    dateOfJoining: '20-Nov-2021',
    overallRating: '4',
    currentSalary: '55000',
    suggestedIncrement: '10',
    incrementStartDate: '01-Jan-2025',
    managementApproval: 'Approved',
    incrementLetter: 'No',
    reviewPeriodStart: 'Jan-2024',
    reviewPeriodEnd: 'Dec-2024',
    periods: ['Jan-2024 to Dec-2024'],
    submissionCount: 1,
    lastSubmission: '2026-03-21T16:45:00',
    ratings: {
      'Did the employee meet their set objectives?': 'Meets Expectations',
      'How would you rate their performance on core responsibilities?': 'Above Average',
      'Technical Skills (Relevant to the job)': 'Proficient',
      'Problem-Solving Abilities': 'Strong',
      'Adaptability and Flexibility': 'Excellent',
      'Professionalism and Work Ethic': 'Good',
      'Accountability and Reliability': 'Good',
      'Punctuality and Attendance': 'Good',
      'Achievements Beyond Expectations': '120% quota achieved in Q3',
      'Eagerness to learn and adapt to new skill': 'High',
    },
    remarks: {
      'Any Complaints or Issues Reported': 'None',
      'Recognition received internally?': 'Yes - Top Sales Q3',
      'Any special projects completed?': 'Enterprise Client Onboarding',
      'Recommend increment based on potential?': 'Recommend',
      'Comfortable with given increment?': 'Yes',
      'Any Other Remarks': 'Strong sales performer. Good client relationships.',
    },
    filledBy: 'sales.head@zylker.com',
    addedTime: '4:45 PM',
  },
];
